<template>
  <div class="question-mian">
    <div class="question-cnt">
      <div class="ques-top">
        <div class="t_999 t_center">第 2 步 (共 3 步)</div>
        <div class="ques-title">请进入商品详情页浏览商品后，回答下方问题，验证所找的商品是否正确。</div>
        <div class="ques-tip">答题Tips：<span class="t_blue" @click="whereSampleImg">店铺名在哪里？</span></div>
      </div>
      <div class="ques-box">
        <div class="ques-box-title">（2/2）{{ curPlatformTypeIsTB ? '店铺名的第1个字是什么？' : '店铺是否为天天特卖工厂店/淘工厂' }}</div>
        <div class="ques-box-select-list">
          <div
            v-for="(item, index) in questionThreeInfo.TextList"
            :key="index"
            :class="{
              'ques-select-item': true,
              active: currentActive === index,
              error: currentErr === index
            }"
            @click="selectItemClick(index)"
          >
            <span class="ques-select-radio list-radio">{{ index | filterSelectText }}</span
            ><span>{{ item }}</span>
          </div>
        </div>
        <div class="ques-box-error" v-show="errTipShow"><span class="iconfont icon-guanbi"></span>很遗憾，回答错误！等待 {{ minErrTime }}s 后再重新选择~</div>
      </div>
    </div>
    <div class="question-btn">
      <div class="question-btn-btn shCancelBtn" @click="goBack">上一步</div>
      <div :class="['question-btn-btn shPrimaryBtn', btnDisabled ? 'disable' : 'sure']" @click="next">{{ btnText }}</div>
    </div>
    <preview-dialog v-if="previewDialogShow" @close="previewDialogShow = false" :img-src="previewImgSrc"> </preview-dialog>
  </div>
</template>

<script>
import CountDownMinx from './minxCountDown'
import { IMG_BASE_URL } from '@/config'
import PreviewDialog from '@/components/puppetComponent/PreviewDialog'
import { Toast, Indicator, MessageBox } from 'mint-ui'
import { ProductVerifyQuestion3, ProductVerifyAnswer3 } from '@/api/question'
import { mapGetters } from 'vuex'

export default {
  name: 'QuestionThree',
  mixins: [CountDownMinx],
  data() {
    return {
      isLoading: false,
      errTipShow: false,
      currentActive: null,
      currentErr: null,
      questionThreeInfo: {},
      previewImgSrc: '',
      previewDialogShow: false,
      sampleImg: IMG_BASE_URL + '/upaiyun/Sys/20190429/5516402861026929809.jpg',
      minErrTime: 15
    }
  },
  computed: {
    ...mapGetters(['getCurPlatformType']),
    // 当前平台是否是淘宝/天猫
    curPlatformTypeIsTB() {
      return this.PLATFORM_TYPE['淘宝'] === this.getCurPlatformType
    }
  },
  mounted() {
    this.btnText = '提交答案'
    this.taskId = this.$route.query.taskID
    if (this.taskId) {
      this.fetchData()
      // if (this.curPlatformTypeIsTB) {
      //   this.fetchData()
      // } else {
      //   // 淘工厂店铺问题只有是和否
      //   this.questionThreeInfo.TextList = ['是', '否']
      // }
    } else {
      Toast('无任务id')
      this.$router.go(-1)
    }
  },
  components: {
    PreviewDialog
  },
  methods: {
    fetchData() {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      ProductVerifyQuestion3({ taskId: this.taskId })
        .then((res) => {
          Indicator.close()
          this.questionThreeInfo = res.Data
          if (this.questionThreeInfo.CountDownSecond) {
            // 倒计时开始
            this.startCountDown(parseInt(this.questionThreeInfo.CountDownSecond))
          }
        })
        .catch((err) => {
          Indicator.close()
          if (err.ErrMsg === '任务不是待搜索的') {
            this.taskTimeOutShow()
          } else {
            Toast(err.ErrMsg)
          }
        })
    },
    // 任务超时显示
    taskTimeOutShow() {
      MessageBox({
        title: '提示',
        message: '当前订单已过期，请重新选择商品~',
        showCancelButton: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        confirmButtonText: '我知道了',
        confirmButtonClass: 't_f23030'
      }).then((action) => {
        if (action === 'confirm') {
          this.$router.replace({ name: 'souhuo' })
        }
      })
    },
    // 条目选择
    selectItemClick(index) {
      this.currentErr = null
      this.errTipShow = false
      this.currentActive = index
    },
    countDownEnd() {
      this.errTipShow = false
      this.currentActive = null
      this.currentErr = null
      document.scrollingElement.scrollTop = 0
    },
    // 提示示例图
    whereSampleImg() {
      this.previewDialogShow = true
      this.previewImgSrc = this.sampleImg
    },
    goBack() {
      this.$router.go(-1)
    },
    next() {
      if (this.btnDisabled) return
      if (this.isLoading) return
      if (this.currentActive === null) {
        let tempTip = this.curPlatformTypeIsTB ? '请选择店铺名' : '请选择答案'
        Toast(tempTip)
        return
      }
      if (!this.taskId) return
      this.errTipShow = false
      this.isLoading = true
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      ProductVerifyAnswer3({
        taskId: this.taskId,
        text: this.questionThreeInfo.TextList[this.currentActive]
      })
        .then((res) => {
          // this.isLoading = false
          Indicator.close()
          Toast('验证通过')
          setTimeout(() => {
            this.$router.replace({
              name: 'stepThree',
              query: {
                readyTaskId: this.taskId
              }
            })
          }, 1000)
        })
        .catch((err) => {
          this.isLoading = false
          Indicator.close()
          this.submitErrHandler(err)
        })
    },
    submitErrHandler(err) {
      this.currentErr = this.currentActive
      if (err.ErrMsg === '回答错误') {
        this.errTipShow = true
        this.minErrTime = err.Data.CountDownSecond
        this.startCountDown(parseInt(this.minErrTime))
        this.$nextTick(() => {
          document.scrollingElement.scrollTop = document.scrollingElement.scrollHeight
        })
      } else if (err.ErrMsg === '进入淘口令模式') {
        let errData = err.Data
        MessageBox({
          title: '提示',
          message: '很遗憾，又回答错误了~请返回上一步，核实搜索商品是否正确。如无误，请点击验证商品链接进行验证。',
          showCancelButton: true,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          cancelButtonText: '上一步',
          confirmButtonText: '验证商品链接',
          confirmButtonClass: 't_f23030'
        }).then((action) => {
          if (action === 'confirm') {
            // 进入淘口令验证
            this.$router.replace({
              name: 'stepTwo',
              query: {
                productId: errData.ProductID,
                keywordID: errData.KeywordID,
                isFreeCard: errData.isFreeCard
              }
            })
          } else {
            this.$router.go(-1)
          }
        })
      } else if (err.ErrMsg === '任务不是待搜索的') {
        this.taskTimeOutShow()
      } else {
        Toast(err.ErrMsg)
      }
    }
  }
}
</script>

<style scoped>
@import './question.css';
</style>
